type LogLevel = "debug" | "info" | "warn" | "error";

const LEVEL_ORDER: Record<LogLevel, number> = {
  debug: 0,
  info: 1,
  warn: 2,
  error: 3,
};

const currentLevel: LogLevel =
  (import.meta.env.MODE === "production" ? "warn" : "debug") as LogLevel;

function shouldLog(level: LogLevel): boolean {
  return LEVEL_ORDER[level] >= LEVEL_ORDER[currentLevel];
}

function formatArgs(tag: string, message: string, data?: unknown): unknown[] {
  const timestamp = new Date().toISOString().slice(11, 23);
  const args: unknown[] = [`%c[${timestamp}] [${tag}] ${message}`, "color: #0ea5e9"];
  if (data !== undefined) args.push(data);
  return args;
}

export function createLogger(tag: string) {
  return {
    debug: (message: string, data?: unknown) => {
      if (shouldLog("debug")) console.debug(...formatArgs(tag, message, data));
    },
    info: (message: string, data?: unknown) => {
      if (shouldLog("info")) console.info(...formatArgs(tag, message, data));
    },
    warn: (message: string, data?: unknown) => {
      if (shouldLog("warn")) console.warn(...formatArgs(tag, message, data));
    },
    error: (message: string, data?: unknown) => {
      if (shouldLog("error")) console.error(...formatArgs(tag, message, data));
    },
  };
}
